import {ClassNames} from "@emotion/react";
import React from "react";
import "./UGDateRangePicker.scss";
import {startOfDay, endOfDay, addDays, subDays} from "date-fns";

import {DateRangePicker} from "rsuite";
import {add_day_in_date} from "../HelpingFunction";

interface Props {
  minDate: Date;
  maxDate: Date;
  placement: any;
}

const UGDateRangePicker: React.FC<Props> = ({minDate, maxDate, placement}) => {
  const range = [
    {
      label: "today",
      value: [startOfDay(new Date()), endOfDay(new Date())],
      closeOverlay: false,
      placement: "bottom",
    },
    {
      label: "last7Days",
      value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
      closeOverlay: false,
      placement: "bottom",
    },
  ];
  return (
    <div className="dateRangePicker" style={{display:"inline-block"}}>
      <DateRangePicker
        defaultValue={[new Date(), new Date()]}
        placement={placement}
        cleanable={false}
        format={"dd-MM-yyyy"}
        editable={false}
        ranges={[
          {
            label: "today",
            value: [startOfDay(new Date()), endOfDay(new Date())],
          },
          {
            label: "yesterday",
            value: [
              startOfDay(addDays(new Date(), -1)),
              endOfDay(addDays(new Date(), -1)),
            ],
          },
          {
            label: "last7Days",
            value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
          },
          {
            label: "Last 30 Days",
            value: [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())],
          },
          {
            label: "Last Month",
            value: [
              startOfDay(
                startOfDay(
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() - 1,
                    1
                  )
                )
              ),
              endOfDay(
                new Date(
                  new Date().getFullYear(),
                  new Date().getMonth() - 1,
                  30
                )
              ),
            ],
          },
          {
            label: "This Month",
            value: [
              startOfDay(
                new Date(new Date().getFullYear(), new Date().getMonth(), 1)
              ),
              endOfDay(
                new Date(new Date().getFullYear(), new Date().getMonth(), 30)
              ),
            ],
          },
          {
            label: "This Year",
            value: [
              startOfDay(new Date(new Date().getFullYear(), 0, 1)),
              endOfDay(new Date(new Date().getFullYear(), 11, 30)),
            ],
          },
        ]}
      />
    </div>
  );
};

export default UGDateRangePicker;
